import React from 'react';
import styles from './Footer.module.css';

function Footer() {
    return(
        <footer>footer</footer>
    );
}

export default Footer;